<template>
  <div class="full-page">
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <div class="page-content">
        <DetailInfo :title="title" :tag="choiceTypeText" :endTime="endTime"  />
        <div class="check-box" v-if="options && choiceType != undefined">
          <!-- 多选 -->
          <van-checkbox-group v-model="result" v-if="choiceType === 1">
            <van-cell-group>
              <van-cell
                v-for="(option, index) in options"
                :key="option.optionId"
                @click="checkboxToggle(index)"
              >
                <template #title>
                  <van-checkbox ref="checkboxes" :name="option.optionId">
                    {{ option.optionName }}
                    <template #icon="props">
                      <img
                        class="img-check"
                        :src="isEnd || choiceStatus ?checkboxInactiveIcon: ( props.checked
                            ? checkboxActiveIcon
                            : checkboxInactiveIcon)
                         
                        "
                      />
                    </template>
                  </van-checkbox>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <!-- 单选 -->
          <van-radio-group v-else-if="choiceType === 0" v-model="result">
            <van-cell-group>
              <van-cell
                v-for="option in options"
                :key="option.optionId"
                @click="radioToggle(option.optionId)"
              >
                <template #title>
                  <van-radio :name="option.optionId">
                    {{ option.optionName }}
                    <template #icon="props">
                      <img
                        class="img-check"
                        :src="isEnd || choiceStatus ?radioInactiveIcon:(props.checked ? radioActiveIcon : radioInactiveIcon)
                        "
                      />
                    </template>
                  </van-radio>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
    </van-pull-refresh>
    <div class="submit-box">
      <van-button
        @click="submit"
        type="primary"
        block
        :disabled="submitDisabled"
        >{{ submitText }}</van-button
      >
    </div>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, RadioGroup, Radio } from "vant";
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { voteDetailAPI, voteSubmitAPI } from "@/api/vote";
import { checkResponse, isTimeEnd } from "@/assets/js/utils";
import DetailInfo from '@/components/DetailInfo'
export default {
  name: "VoteDetail",
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    DetailInfo
  },
  data() {
    return {
      checkboxActiveIcon: require("@/assets/images/checkbox_active.png"),
      checkboxInactiveIcon: require("@/assets/images/checkbox_inactive.png"),
      radioActiveIcon: require("@/assets/images/radio_active.png"),
      radioInactiveIcon: require("@/assets/images/radio_inactive.png"),
      detailId: 0,
      isRefresh: false,
      title: "",
      endTime: undefined,
      choiceType: undefined, //0-单选 1多选
      options: undefined,
      result: undefined,
      choiceStatus: true,
    };
  },
  computed: {
    isEnd() {
      let isEnd = false;
      if (this.endTime !== undefined && this.endTime != null) {
        isEnd = isTimeEnd(this.endTime);
      }
      return isEnd;
    },
    choiceTypeText() {
      return this.choiceType != undefined
        ? this.choiceType === 0
          ? "单选"
          : "多选"
        : "";
    },
    submitDisabled() {
      let disabled = true;
      if (this.choiceStatus) {
        // 已投票
        disabled = true;
      } else if (this.isEnd) {
        // 已结束
        disabled = true;
      } else if (
        this.result === null ||
        this.result === undefined ||
        this.result.length === 0
      ) {
        // 还没选
        disabled = true;
      } else {
        disabled = false;
      }
      return disabled;
    },
    submitText() {
      let text = "";
      if (this.choiceStatus) {
        text = "已投票";
      } else if (this.isEnd) {
        text = "已结束";
      } else {
        text = "投票";
      }
      return text;
    },
  },
  mounted() {
    BridgeNativeMethods.setTitle("投票");
    
    this.detailId = parseInt(this.$route.params.id);
    this.requestData();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      voteDetailAPI(this.detailId).then(
        (response) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
            let { title, endTime, options, choiceType, choiceStatus } = response.data;
            this.choiceType = choiceType;
            this.endTime = endTime;
            this.title = title;
            this.options = options;
            this.choiceStatus = choiceStatus;
          
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log("activity detail err", err);
        }
      );
    },
    onRefresh() {
      this.isRefresh = true;
      this.requestData();
    },
    checkboxToggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    radioToggle(optionId) {
      return this.result = optionId
    },
    submit() {
      console.log(this.result);
      if (
        this.result === null ||
        this.result === undefined ||
        this.result.length === 0
      ) {
        BridgeNativeMethods.showToast("请选择");
      } else {
        BridgeNativeMethods.showLoading();
        let choiceOptionIds;
        if (this.choiceType == 0) {
          choiceOptionIds = [this.result];
        } else if (this.choiceType == 1) {
          choiceOptionIds = this.result;
        }
        voteSubmitAPI({
          voteId: this.detailId,
          choiceOptionIds,
        }).then(
          (response) => {
            if (checkResponse(response)) {
              console.log(response.data);
              // 跳转结果
              BridgeNativeMethods.navigateVoteResult({
                id:this.detailId
              })
            } else {
              BridgeNativeMethods.showToast(response.message);
            }
          },
          (err) => {
            BridgeNativeMethods.hideLoading();
            BridgeNativeMethods.showToast("请求错误");
            console.log("activity detail err", err);
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  min-height: 100vh;
  margin-bottom: 65px;
}
.info {
  background-color: #fff;
  padding: 16px;
}
.title {
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  vertical-align: middle;
}
.tag {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  background: @theme-orange;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  margin-left: 8px;
}
.time {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 8px;
}
.description {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
  margin-top: 10px;
}
.check-box {
  background-color: #fff;
  margin-top: 16px;
}
.submit-box {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 8px;
  z-index: 10;
  background: #ffffff;
}
/deep/.van-checkbox__label {
  margin-left: 16px;
}
/deep/.van-cell::after {
  left: 62px;
  right:0;
}
/deep/.van-checkbox__icon,
/deep/.van-radio__icon {
  height: 24px;
  line-height: 24px;
}
/deep/.van-button--disabled {
  background-color: #d8d8d8;
  opacity: 1;
  border-color: #d8d8d8;
}
.img-check {
  width: 24px;
  height: 24px;
}
</style>